import { Box, Container, Stack, Typography } from '@mui/material';
import { get } from 'lodash';
import { ComponentType, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { State } from 'src/common/store';
import { Loader } from 'src/components/loader';
import { dateFormat } from 'src/hooks';
import { PageLayout } from 'src/layouts/page-layout';
import { getPost } from 'src/thunks/news-thunk';
import { NewsBlock } from '../news-block';

interface NewsDetailsProps {
  id: string | number;
}
export const NewsDetails: ComponentType<NewsDetailsProps> = ({ id: someId }) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const { id }: Record<string, any> = useParams();

  // console.log('params', params);

  useEffect(() => {
    dispatch(getPost({ id, embed: 'cover', language: i18n.language }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language, id]);

  const { isLoading, data } = useSelector((state: State) => state.news.post);

  if (isLoading) return <Loader />;

  if (!data) return null;

  return (
    <PageLayout title={data.title}>
      <Container>
        <Stack gap={3} pb={5}>
          {data.cover && (
            <Box
              component="img"
              src={get(data, ['cover', 'fullPath'])}
              alt={data.title}
              maxWidth={1}
              alignSelf="center"
            />
          )}
          <Typography variant="subtitle2" textAlign="right">
            {dateFormat(data.createdAt, 'D.M.Y')}
          </Typography>
          <Box dangerouslySetInnerHTML={{ __html: data.description }} />

          {data.attachment && (
            <Box component="a" href={data.attachment} download>
              {t('action.download.file', 'Скачать файл')}
            </Box>
          )}
        </Stack>

        <Box py={5}>
          <NewsBlock title={t('portalNews', 'Новости портала')} showItems={3} mb={8} allNewsLink />
        </Box>
      </Container>
    </PageLayout>
  );
};
